import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const EditIcon = (props) => (
    <SvgIcon viewBox="0 0 16 16" sx={{ ...props }}>
        <path d="M6.162 12.6667H14V14.0001H2V11.1714L8.6 4.57139L11.428 7.40072L6.16133 12.6667H6.162Z" fill="currentColor" />
        <path d="M9.542 3.62939L10.9567 2.21472C11.0817 2.08974 11.2512 2.01953 11.428 2.01953C11.6048 2.01953 11.7743 2.08974 11.8993 2.21472L13.7853 4.10072C13.9103 4.22574 13.9805 4.39528 13.9805 4.57206C13.9805 4.74883 13.9103 4.91837 13.7853 5.04339L12.3707 6.45739L9.54267 3.62939H9.542Z" fill="currentColor" />
    </SvgIcon>
);

export default EditIcon;
